import React, { useEffect, useState } from 'react'
import { FaAngleRight, FaFilePrescription } from 'react-icons/fa';
import { FiArrowLeft, FiSearch } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

function MobileSearchPage() {

    const navigate = useNavigate()
    const [searchInput, setSearchInput] = useState('')
    const [cartItems, setCartItems] = useState(() => JSON.parse(localStorage.getItem('cart')) || []);
    const [cartLength, setCartLength] = useState(cartItems.length || 0);

    useEffect(() => {
        setCartLength(cartItems.length || 0);
    }, [cartItems]);

    // BUG-12: this page carried an empty try/catch useEffect and an unused
    // `products` state — the remains of an autocomplete that was never built.
    // Removed rather than left in place, because dead scaffolding reads as
    // "something fetches here" to the next person. Autocomplete itself is a
    // feature decision, not a bug, so it is not being invented here.

    // Submitting an empty query navigated to /search-result/undefined, which
    // then searched for the literal string "undefined".
    const submitSearch = (e) => {
        e.preventDefault();
        const query = (searchInput || '').trim();
        if (!query) return;
        navigate(`/search-result/${encodeURIComponent(query)}`);
    };

    return (
        <>
            <div style={{ height: "100%", width: "100%" }}>

                <section className="mobile-search-pannel">
                    {/* A form, so the mobile keyboard's own Search/Go key submits —
                        previously only the magnifier icon worked, which on a phone
                        is the harder target and not what the keyboard offers. */}
                    <form className="search-bar" onSubmit={submitSearch}>
                        <FiArrowLeft className="icon left-icon" onClick={() => navigate('/')} />
                        <input
                            type="search"
                            placeholder="Search medicines & health products"
                            className="search-input"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            autoFocus
                        />
                        <div className="mic-icon-wrapper">
                            <button
                                type="submit"
                                className="search-submit-btn"
                                aria-label="Search"
                                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                            >
                                <FiSearch className="icon mic-icon" />
                            </button>
                        </div>
                    </form>

                    <div className="prescription-banner d-flex">
                        <FaFilePrescription style={{ fontSize: "26px" }} />
                        <p>Have a prescription? Order quickly!</p>
                        <FaAngleRight style={{ fontSize: "26px" }} />
                    </div>
                </section>

                <div className="cart-footer-mobile">
                    <div className="d-flex" style={{ justifyContent: "space-between" }}>
                        <div>
                            <span style={{ fontSize: "14px", color: "gray" }}>Added</span>
                            <h3>{cartLength} items in cart</h3>
                        </div>
                        <button onClick={() => navigate('/cart')}>Go to cart</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileSearchPage